const state = {
	msgCount: 0
}

const mutations = {
	SET_MsgCount: (state, data) => {
		state.msgCount = data
	},
}

const actions = {
	ChageMsg({ commit },data) {
		return new Promise(resolve => {
			commit('SET_MsgCount', data)
			resolve(data)
		})
	},
}

export default {
	namespace: true,
	actions,
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js